import React from 'react';
import Lightbox from 'react-image-lightbox';
import Img from 'gatsby-image';

import Section from '../components/Section';
import styles from './Photos.module.scss';

const Photo = ({ title, className, image, index, photoTouchedAtIndex }) => {
  const imageComponent =
    typeof image === 'string' ||
    image instanceof String ||
    image === undefined ? (
      <img className={styles.photoItem} src={image} alt={title} />
    ) : (
      <Img
        className={styles.photoItem}
        fluid={image.childImageSharp.fluid}
        alt={title}
      />
    );
  return (
    <div
      className={`${className} ${styles.photo}`}
      onClick={() => {
        photoTouchedAtIndex ? photoTouchedAtIndex(index) : null;
      }}
    >
      <div className={styles.photoRatio}>{imageComponent}</div>
    </div>
  );
};

const Photos = ({ items, title }) => {
  const className = items && styles[`photo${Math.min(6, items.length)}`];
  if (items && items.length > 0) {
    const [lightbox, setLightbox] = React.useState({
      isOpen: false,
      index: 0
    });

    return (
      <>
        <Section light title={title}>
          {lightbox.isOpen && (
            <Lightbox
              mainSrc={items[lightbox.index].image.publicURL}
              nextSrc={
                items[(lightbox.index + 1) % items.length].image.publicURL
              }
              prevSrc={
                items[(lightbox.index + items.length - 1) % items.length].image
                  .publicURL
              }
              onCloseRequest={() => setLightbox({ isOpen: false, index: 0 })}
              onMovePrevRequest={() =>
                setLightbox({
                  isOpen: true,
                  index: (lightbox.index + items.length - 1) % items.length
                })
              }
              onMoveNextRequest={() =>
                setLightbox({
                  isOpen: true,
                  index: (lightbox.index + 1) % items.length
                })
              }
            />
          )}
          <div className={styles.photos}>
            {items.map((photo, index) => (
              <Photo
                className={className}
                title={photo.title}
                image={photo.image}
                key={photo.title + index}
                index={index}
                photoTouchedAtIndex={photoIndex => {
                  setLightbox({
                    isOpen: true,
                    index: photoIndex
                  });
                }}
              />
            ))}
          </div>
        </Section>
      </>
    );
  }
  return <></>;
};

export default Photos;
